import each from './each';
import isArrayLike from './is-array-like';

var map = function (arr, func) {
  if (!isArrayLike(arr)) {
    // @ts-ignore
    return arr;
  }

  var result = [];
  each(arr, function (value, index) {
    result.push(func(value, index));
  });
  return result;
};

export default map;


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@antv_util@2.0.7@@antv/util/esm/map.js
// module id = 101
// module chunks = 0